<template>
	<section class="simplebar-content-wrapper">
		<section class="wallet-wrapper p-0">
			<div class="back_deposit_page">
				<button type="button" class="back_arrow_btn" @click="$router.go(-1)">
					<i class="fa-solid fa-angle-left"></i>
				</button>
				<span>{{ $t('wallet', 'Wallet') }}</span>
			</div>
			<div class="ms-container">
				<div class="wallet_net-expouser-sec trans-rapper">
					<div v-if="$auth?.user">
						<ul>
							<li>
								<p class="text-white">
									<span class="wallet_lft_title">{{ $t('wallet-amount', 'Wallet Amount') }}</span> 
									<span>:</span>
									<span class="success_text"> {{ $auth?.user?.balance }}</span>
								</p>
							
								<p class="inclusive_bonus_title">( {{ $t('inclusive-bonus', 'Inclusive bonus') }})</p>
							</li>
							<li>
								<p class="text-white">
									<span class="wallet_lft_title">{{ $t('net-exposure', 'Net Exposure') }}</span>
									<span>:</span> 
									<span class="error_text"> {{ $auth?.user?.exposure ? $auth?.user?.exposure : 0 }}</span>
								</p>
							</li>
							<li>
								<p class="text-white">
									<span class="wallet_lft_title">{{ $t('available-withdrawal', 'Available Withdrawal') }}</span> 
									<span>:</span>
									<span class="success_text"> {{ ($auth?.user?.balance + ($auth?.user?.exposure || 0))?.toFixed(2) }}</span>
								</p>
							</li>
						</ul>
					</div>
					<div>
						<hr class="v_divider">
					</div>
					<div class="wallet-btn">
						<ul>
							<li>
								<router-link v-if="!this.$auth.user.isDemo" :to="{ name: 'wallet-deposit' }" class="thm-but">
									{{ $t('deposit', 'DEPOSIT') }} <span><i class="fa-solid fa-angle-right"></i></span>
								</router-link>
								<router-link v-else :to="{ name:'Home' }" @click="$errorToast((this.$t('wallet-access-is-restricted-for-demo-user', 
                                    'Wallet Access Is Restricted For Demo User')))" class="thm-but">
									{{ $t('deposit', 'DEPOSIT') }} <span><i class="fa-solid fa-angle-right"></i></span>
								</router-link>
							</li>
							<li>
								<!-- <div class="border--golden"> -->
									<router-link  v-if="!this.$auth.user.isDemo" :to="{ name: 'wallet-withdraw' }" class="thm-but">
										{{ $t('withdrawal', 'WITHDRAWAL') }} <span><i class="fa-solid fa-angle-right"></i></span>
									</router-link>
									<router-link   v-else :to="{ name:'Home' }" class="thm-but" @click="$errorToast((this.$t('wallet-access-is-restricted-for-demo-user', 
                                    'Wallet Access Is Restricted For Demo User')))">
										{{ $t('withdrawal', 'WITHDRAWAL') }} <span><i class="fa-solid fa-angle-right"></i></span>
									</router-link>
								<!-- </div> -->
							</li>
							<li>
								<router-link v-if="!this.$auth.user.isDemo" :to="{ name: 'transactions' }" class="thm-but">
									{{ $t('view-all-transactions', 'VIEW ALL TRANSACTIONS') }} <span><i class="fa-solid fa-angle-right"></i></span>
								</router-link>
								<router-link v-else :to="{ name: 'Home' }" @click="$errorToast((this.$t('wallet-access-is-restricted-for-demo-user', 
                                    'Wallet Access Is Restricted For Demo User')))"  class="thm-but">
									{{ $t('view-all-transactions', 'VIEW ALL TRANSACTIONS') }} <span><i class="fa-solid fa-angle-right"></i></span>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</section>
</template>

<script>
export default {
    name: "Wallet",
    inject: ['walletHeader'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        userData() {
            return this.$store.getters.stateUser;
        }
    }
}
</script>
